import React, { useState, useEffect } from "react";
import ArticleItem from "./ArticleItem";

import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import Paginate from "../../common/Paginate";
import { useEyeconxStore } from "../../../store/eyeconxStore";
import articlesService from "../../../services/articles.service";
import {toast} from 'react-toastify';

function ArticlesList({
  articlesList = [],
  itemsPerPage = 5,
  currentPage = 1,
  totalPages,
  paginate,
  pageNumbers = [],
  headingText = "Articles",
  searchTerm,
  handleClearSearchTerm,
}) {
  const [showModal, setShowModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState([]);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const [articlesListThis, setArticlesListThis] = useState(articlesList);
  const [selectionClear, setSelectionClear] = useState(false);
  const [checkedItems, setCheckedItems] = useState(
    articlesList.map(() => false)
  );
  const todaysAppointment = useEyeconxStore((state) => state.todaysAppointment);
  const user = useEyeconxStore((state) => state.user);
  const [searchPatientEmail, setSearchPatientEmail] = useState("");
  const [searchPatientList, setSearchPatientList] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [customMessage, setCustomMessage] = useState("Here is an interesting article for you to read.");
  //Add id to selectedArticle on checkbox checked
  const handleCheckboxChange = (e, article, index) => {
    const newCheckedItems = [...checkedItems];
    newCheckedItems[index] = !newCheckedItems[index];
    setCheckedItems(newCheckedItems);
    if (e.target.checked) {
      setSelectedArticle([...selectedArticle, article.id]);
    } else {
      setSelectedArticle(selectedArticle.filter((id) => id !== article.id));
    }
  };

  const handleClearSelectedArticle = () => {
    setSelectedArticle([]);
    setCheckedItems(articlesList.map(() => false));
  };
  useEffect(() => {
    setArticlesListThis(articlesList);
  }, [articlesList]);

  const sendArticleToPatient = () => {
    //console.log("sendArticleToPatient");
    const data = {
      mediumType:"EMAIL",
      articleIds: selectedArticle,
      patientId: selectedPatient.patientId,
      customMessage : customMessage,
    };
    articlesService
      .sendArticleToPatient(user.clinicId, data)
      .then((res) => {
        console.log("sendArticleToPatient", res);
        handleCloseModal();
        handleClearSelectedArticle();
        toast.success("Articles sent successfully");
      })
      .catch((err) => {
        console.log("sendArticleToPatient", err);
        toast.error("Error sending articles");
        handleCloseModal();
        
      });
  };
 
  const handleSelectedPatient = (selected_patient) => {
    setSelectedPatient(selected_patient);
  };
  return (
    <>
      <div className="d-flex justify-content-md-between mb-2">
        <div>
          <h2>{headingText}</h2>
        </div>
        <div>
          <div>
            {selectedArticle.length > 0 && (
              <>
                <button
                  className="btn btn-sm btn-light-info ms-2"
                  onClick={handleShowModal}
                >
                  Send selected {selectedArticle.length}{" "}
                  {selectedArticle.length === 1 ? "article" : "articles"} to
                  patient
                </button>
                <button
                  className="btn btn-sm btn-light-warning ms-2"
                  onClick={handleClearSelectedArticle}
                >
                  Clear
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <Paginate
        position="end"
        totalPages={totalPages}
        currentPage={currentPage}
        paginate={paginate}
        pageNumbers={pageNumbers}
      />
      {articlesListThis.length === 0 ? (
        <h2>No Articles Found</h2>
      ) : (
        <>
          {articlesListThis &&
            articlesListThis.map((article, index) => (
              <ArticleItem
                key={index}
                chindex={index}
                article={article}
                handleCheckboxChange={handleCheckboxChange}
                checkedItem={checkedItems[index]}
              />
            ))}
        </>
      )}
      <Paginate
        position="center"
        totalPages={totalPages}
        currentPage={currentPage}
        paginate={paginate}
        pageNumbers={pageNumbers}
      />

      <Modal
        size="lg"
        centered
        scrollable
        show={showModal}
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Patient</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-7">
              <div className="">
                <span className="form-label">Select patient from today's appointment</span>
                <hr></hr>
                {todaysAppointment &&
                  todaysAppointment.map((appointment, index) => (
                    <span
                      className="badge badge-secondary text-hover-primary m-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSelectedPatient(appointment)}
                    >
                      {appointment.firstName} {appointment.lastName}
                    </span>
                  ))}
              </div>
            </div>
            <div className="col-5">
              <div className="d-flex flex-column justify-content-center align-items-center mb-3">
                <div className="form-group me-2 mb-3">
                  <label htmlFor="" className="form-label">
                    Custom Message
                  </label>
                  <textarea
                    name=""
                    id=""
                    rows="5"
                    className="form-control"
                    value={customMessage}
                    onChange={(e) => setCustomMessage(e.target.value)}
                  ></textarea>
                </div>

                {selectedPatient && selectedArticle.length > 0 && (
                  <>
                    <div>
                      <span className="text-gray-900 fw-bold">
                        Selected {selectedArticle.length}{" "}
                        {selectedArticle.length > 1 ? "articles" : "article"}{" "}
                        for
                        {selectedPatient &&
                          " " +
                            selectedPatient.firstName +
                            " " +
                            selectedPatient.lastName}
                      </span>
                    </div>
                    <button
                      onClick={sendArticleToPatient}
                      className="btn btn-success mt-2 mb-3"
                    >
                      <i className="bi bi-send"></i> Send
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ArticlesList;
